const ReferBonusManagementData = [
    {
        id: 1,
        name: 'Amity University Online',
        logo: '/assets/images/university-logo/amity-logo.png',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
    {
        id: 2,
        name: 'Indira Gandhi National Open University',
        logo: '',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
    {
        id: 3,
        name: 'Sushant University',
        logo: '',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
   
    {
        id: 4,
        name: 'Narsee Monjee Institute of Management Studies',
        logo: '',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
    {
        id: 5,
        name: 'Shiv Nadar University',
        logo: '',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
    {
        id: 6,
        name: 'LPU Distance Education',
        logo: '',
        courser: 'UG Courser',
        ugbonusAmount: '₹4200.00',
        pgCourser: '',
        pgBonusAmt: '₹5200.00',
        doctorate: '',
        doctorateBonusAmt: '₹6200.00',
        action: '',
    },
   
];

export default ReferBonusManagementData;
